export const customImageCrops = {
    jumbotronLargeCrops: {
        small: {
            width: 480,
            height: 257
        },
        medium: {
            width: 720,
            height: 386
        },
        large: {
            width: 940,
            height: 504
        }
    }
};
